import { Component, DestroyRef, inject, signal } from '@angular/core';
import { SalesTypeService } from '../../services/sales-type.service';
import { SalesType } from '../../models/sales-type.model';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { DynamicRouteHandlingService, InputFieldComponent } from '@zayan-erp/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { rxResourceFixed } from '@zayan-erp/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { of, tap } from 'rxjs';
@Component({
  selector: 'lib-sales-type-form',
  imports: [InputFieldComponent, ReactiveFormsModule],
  templateUrl: './sales-type-form.component.html'
})
export class SalesTypeFormComponent {
  #salesTypeService = inject(SalesTypeService);
  #dynamicRouteHandling = inject(DynamicRouteHandlingService);
  #activatedRoute = inject(ActivatedRoute);
  #router = inject(Router);
  #destroyRef = inject(DestroyRef);
  selectedSalesTypeId = signal<string | null>(this.#activatedRoute.snapshot.paramMap.get('id'));

  salesTypeForm = new FormGroup({
    code: new FormControl<string | null>(null, Validators.required),
    description: new FormControl<string | null>(null, Validators.required),
    salesAllocationRules: new FormControl<boolean>(false, Validators.required)
  });

  constructor() {
    this.#dynamicRouteHandling.submitButton$.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => {
      this.submitSalesTypeForm();
    });
  }

  editRxResource = rxResourceFixed({
    params: () => ({ id: this.selectedSalesTypeId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (params.id) {
        return this.#salesTypeService.getSalesTypeById(params.id).pipe(tap(salesType => this.editForm(salesType)));
      }
      return of(null);
    }
  });
  editForm(salesType: SalesType) {
    this.salesTypeForm.patchValue({
      code: salesType.code,
      description: salesType.description,
      salesAllocationRules: salesType.salesAllocationRules
    });
  }

  submitSalesTypeForm() {
    if (this.salesTypeForm.invalid) {
      this.salesTypeForm.markAllAsTouched();
      return;
    }
    if (this.selectedSalesTypeId()) {
      this.#salesTypeService
        .updateSalesType(this.selectedSalesTypeId()!, this.salesTypeForm.value as SalesType)
        .subscribe({
          next: () => this.afterSubmit()
        });
    } else {
      this.#salesTypeService.createSalesType(this.salesTypeForm.value as SalesType).subscribe({
        next: () => this.afterSubmit()
      });
    }
  }
  afterSubmit() {
    this.#dynamicRouteHandling.reload.next(!this.#dynamicRouteHandling.reload.value);
    this.#router.navigate([this.#activatedRoute.snapshot.data['returnRoute']], { queryParamsHandling: 'preserve' });
  }
}
